/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpWideShort: {
  name: 'arrow-up-wide-short';
  data: string;
} = {
  name: 'arrow-up-wide-short',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 0 0-2 0v13l-1.2-1.6a1 1 0 1 0-1.6 1.2l3 4a1 1 0 0 0 1.6 0l3-4a1 1 0 0 0-1.6-1.2L7 17V4Zm6 2a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2h-8Zm-1 6a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2h-2Z" fill="currentColor"/></svg>`,
};
